import { UserGroupClient, UserGroupServer } from './UserGroupsTypes';

export const mapUserGroupServerToClient = (server: UserGroupServer): UserGroupClient => ({
  createdAt: server.created_at,
  description: server.description,
  name: server.name,
  memberCount: server.member_count || 0
});
